import { render, staticRenderFns } from "./Forro.vue?vue&type=template&id=7533647a&scoped=true&lang=pug&"
import script from "./Forro.vue?vue&type=script&lang=js&"
export * from "./Forro.vue?vue&type=script&lang=js&"
import style0 from "./Forro.vue?vue&type=style&index=0&id=7533647a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7533647a",
  null
  
)

export default component.exports
import {QPage,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBtn})
